routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider) {
    $stateProvider
        .state('home.boxTextTemplate', {
            url: "box-text-template",
            template: `<box-text-template sh-ctrl="shCtrl"></box-text-template>`
        });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/box-text-template/box-text-template.config.js